import { ActionIcon, BrandImage, Categories, MobileMenu, NavbarWrapper, NavItem, NavItemMobile } from "./styles"
import BrandLogo from '../../assets/img/celeste-logo.png'
import { NavLink } from "react-router-dom"
import { categories } from "../../util/sharedData"
import { globalStyles } from "../../util/globalStyles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons"
import { useEffect, useRef, useState } from "react"

export const Navbar = () => {
    const ref = useRef(null)
    const [ showMenu, setShowMenu ] = useState(false)

    // Close sideNav on outside click
    useEffect(() => {
        const outsideClickListener = (e) => {
            if(showMenu && !ref.current.contains(e.target)) {
                setShowMenu(false)
            }
        }
        if(showMenu) {
            setTimeout(() => window.addEventListener('click', outsideClickListener), 0)
        }
        return () => {
            window.removeEventListener('click', outsideClickListener)
        }
    }, [showMenu, setShowMenu])

    return (
        <NavbarWrapper>
            <NavLink to='/'>
                <BrandImage src={BrandLogo} alt='Brand Logo' />
            </NavLink>
            {
                window.screen.width > parseInt(globalStyles.breakpoints.medium.substring(0, globalStyles.breakpoints.medium.length-2)) ?
                    <Categories>
                        {
                            categories.map((category, idx) => (
                                <NavLink 
                                    to={category.path} 
                                    key={idx}
                                    style={({isActive}) => ({
                                        color: isActive ? "blue" : "black",
                                    })}
                                    >
                                    <NavItem>{category.name}</NavItem>
                                </NavLink>
                            ))
                        }
                    </Categories>
                :
                    <ActionIcon onClick={() => setShowMenu(showMenu ? false : true)}>
                        <FontAwesomeIcon icon={showMenu ? faXmark : faBars} size="2x" color="#222" />
                    </ActionIcon>
            }
            {
                showMenu && 
                <MobileMenu ref={ref}>
                    {
                        categories.map((category, idx) => (
                            <NavLink 
                                to={category.path} 
                                key={idx}
                                style={({isActive}) => ({
                                    color: isActive ? "blue" : "black",
                                })}
                                onClick={() => setShowMenu(false)}
                                >
                                <NavItemMobile>{category.name}</NavItemMobile>
                            </NavLink>
                        ))
                    }
                </MobileMenu>
            }
        </NavbarWrapper>
    )
}